
import {useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';



export interface DropDownProps {
    filterable?: boolean
    data?: any
    onFilterChange?: (event) => void
    loading?: boolean
    textField?: string
    label?: string
    name?: string
    value?: any
    onChange?: (event) => void
    dataItemKey?: string
    showExtraPadding?: boolean
    itemRender?:any
    style?:any
    className?:string,
    required?:boolean
    defaultValue?:any
    key?:any
    disabled?:boolean
    filter?:any
    validityStyles?:any
    onOpen?:any
    opened?:boolean
    ariaDescribedBy?:any
    valueRender?:any

}


function DropDownListComponent(props: DropDownProps) {
    const {
        filterable,
        data,
        onFilterChange,
        loading,
        textField,
        label,
        name,
        value,
        onChange,
        dataItemKey,
        itemRender,
        style,
        className,
        required,
        defaultValue,
        key,
        disabled,
        filter,
        validityStyles,
        onOpen,
        opened,
        ariaDescribedBy,
        valueRender

    } = props

    // const [filter, setFilter] = useState(data?.slice());


    return (
        <div>
            <label>{label}</label>
            <DropDownList
                filterable={filterable}
                data={data}
                onFilterChange={onFilterChange}
                loading={loading}
                textField={textField}
                name={name}
                value={value}
                onChange={onChange}
                dataItemKey={dataItemKey}
                itemRender={itemRender}
                style={style}
                className={className}
                required={required}
                defaultValue={defaultValue}
                key={key}
                disabled={disabled}
                filter={filter}
                validityStyles={validityStyles}
                onOpen={onOpen}
                opened={opened}
                ariaDescribedBy={ariaDescribedBy}
                valueRender={valueRender}
            />


            {/* (canReFetch && !loading) &&
                     <div className={showExtraPadding?"position-absolute mr-n2 staffDoc-refresh-button-single-selection":"position-absolute mr-n2 staffDoc-refresh-button"}>
                     <RefreshButton
                         onRefresh={onRefetch }
                     />
                 </div> */
            }

            {/* {
                error &&
                <Error >
                    {error}
                </Error>
            } */}
        </div>


    );

}
export default DropDownListComponent;



